export default __webpack_public_path__ + "static/media/default.aa2e053a296cd52c5627bbadf447f8df.png";